import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const useAuth = () => {
  const accessToken = sessionStorage.getItem('accessToken');

  if (accessToken) {
    return true;
  } else {
    return false;
  }
};

const PrivateRoute = () => {
  const auth = useAuth();
  return auth ? <Outlet /> : <Navigate to="/login" />;
};

export default PrivateRoute;
